export default __webpack_public_path__ + "static/media/item-4.4f96bba3.png";